import { Input as MantineInput } from '@mantine/core';
import inputWrapperStyles from '../styles/Input.module.css';
import { FC } from 'react';

export type MantineInputWrapperProps = React.ComponentProps<typeof MantineInput.Wrapper>;

export const InputWrapper: FC<MantineInputWrapperProps> = props => {
    return (
        <MantineInput.Wrapper
            classNames={{
                label: inputWrapperStyles.label,
                description: inputWrapperStyles.description,
                required: inputWrapperStyles.required,
            }}
            {...props}
        />
    );
};
